import { Modal } from "bootstrap";
import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ConvertToBoolean, isValidArray } from "../common";
import { axiosInstance } from "../../../axios/axiosInstance";
import { useAuth } from "../../../Context/AuthContext";
import { PAGES } from "../../../routeConfig";
import "./overDuePopUp.css";

export const OverDuePopup = ({ onDone, canShow = true }) => {
  const { companyId, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const modalRef = useRef(null);
  const modalInstanceRef = useRef(null);
  const checkingRef = useRef(false);
  const [pendingShow, setPendingShow] = useState(false);

  useEffect(() => {
    if (checkingRef.current) return;
    if (
      !isAuthenticated ||
      !companyId ||
      ConvertToBoolean(localStorage.getItem("checkOverDuePopup")) ||
      location.pathname.toLowerCase().startsWith(PAGES.PAYACCOUNT)
    ) {
      onDone?.();
      return;
    }
    checkOverDue();
  }, [isAuthenticated, companyId]);

  useEffect(() => {
    if (!pendingShow || !canShow) return;
    setPendingShow(false);
    setTimeout(() => modalInstanceRef.current?.show(), 750);
  }, [pendingShow, canShow]);

  useEffect(() => {
    const element = modalRef.current;
    const handleHidden = () => onDone?.();
    element?.addEventListener("hidden.bs.modal", handleHidden);
    return () => {
      element?.removeEventListener("hidden.bs.modal", handleHidden);
      modalInstanceRef.current?.dispose();
    };
  }, []);

  const checkOverDue = async () => {
    checkingRef.current = true;
    let shown = false;
    try {
      localStorage.setItem("checkOverDuePopup", true);
      const response = await axiosInstance.post(`CompanyUsers/CheckOverDue?CompanyId=${parseInt(companyId, 10)}`);
      const data = typeof response.data === "string" && response.data ? JSON.parse(response.data) : response.data;
      if (isValidArray(data) && modalRef.current) {
        modalInstanceRef.current = new Modal(modalRef.current, {
          backdrop: true,
          keyboard: true,
        });
        setPendingShow(true);
        shown = true;
      }
    } catch (e) {
      console.error(e);
    }
    if (!shown) onDone?.();
  };

  const closeModal = () => {
    modalInstanceRef.current?.hide();
  };

  const handlePayNow = () => {
    closeModal();
    navigate(PAGES.PAYACCOUNT);
  };

  return (
    <div ref={modalRef} className="modal fade" id="overDuePopupdiv" tabIndex={-1} aria-labelledby="overDuePopupLabel">
      <div className="modal-dialog iop-modal">
        <div className="modal-content iop-dialog" role="alertdialog" aria-describedby="iop-message">
          <div className="iop-body">
            <div className="iop-icon-wrap" aria-hidden="true">
              <span className="iop-wave" />
              <span className="iop-icon-circle">
                <svg
                  width="22"
                  height="22"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <g className="iop-bell">
                    <path d="M18 8a6 6 0 00-12 0c0 7-3 9-3 9h18s-3-2-3-9" />
                    <path d="M12 2v1" />
                  </g>
                  <path className="iop-clapper" d="M13.7 21a2 2 0 01-3.4 0" />
                </svg>
              </span>
            </div>
            <div className="iop-text">
              <h2 id="overDuePopupLabel" className="iop-title">
                Invoice Payment Overdue
              </h2>
              <p id="iop-message" className="iop-message">
                Please settle your account as soon as possible to avoid your account being locked.
              </p>
            </div>
          </div>
          <div className="iop-actions">
            <button type="button" className="iop-cancel" onClick={closeModal}>
              Remind Me Later
            </button>
            <button type="button" className="iop-pay" onClick={handlePayNow}>
              Pay now
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
